import type { UnitTileSize } from './types';

/**
 * Rendered CSS size, in pixels, of each `UnitTileSize`.
 *
 * Used to build the `sizes` attribute that accompanies an icon `srcSet`, which is
 * how the browser learns how large the tile actually renders and therefore which
 * rendition to fetch.
 *
 * ⚠️ MUST stay in sync with the `width`/`height` declared for each size in
 * `boxStyles` in `./index.tsx`. Compiled's `cssMap` requires statically
 * analysable literals, so the CSS cannot be generated from this map. Instead
 * `__tests__/unit/sizes.tsx` asserts the two agree, so drift fails a test rather
 * than silently mis-sizing every icon.
 */
export const UNIT_TILE_SIZE_PX: Record<UnitTileSize, number> = {
	xsmall: 20,
	small: 24,
	medium: 32,
	large: 48,
};
